import { Spin, Tabs } from 'antd';
import React, { useEffect, useState, useMemo } from 'react';
import { BiArrowBack } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../routes/RoutesURL';
import { RootState } from '../../../store/rootReducer';
import { dealTypes } from '../../login/utils/Status';
import InvestmentDistribution from './components/Details/Destribution';
import InvestmentDetailCard from './components/Details/DetailCard';
//import ExecutedAgreements from './components/Details/ExecutedAgreements';
import Performances from './components/Details/Performances';
import RepaymentSchedules from './components/Details/RepaymentSchedules';
//import ReportingOrUpdates from './components/Details/ReportingOrUpdates';
import InvestmentsActions from './redux/actions';
import InvestmentDocuments from './components/Details/Documents';
import BookingInformation from './components/Details/information';
import { common_container } from '../dealList/components/deals/TopCard';

const { TabPane } = Tabs;

const InvestmentDetails: React.FC = () => {
    const investmentUUID = useParams().uuid;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loading = useSelector((state: RootState) => state.investments.detailLoading);
    const type = useSelector((state: RootState) => state.investments.investmentDetails?.deal?.info.summary?.dealType);
    const bookingUUID = useSelector((state: RootState) => state.investments.investmentDetails?.bookingUUID);
    const investorUUID = useSelector((state: RootState) => state.user.uuid);
    const [activeTab, setTab] = useState('1');

    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab');

    useEffect(() => {
        if (tab) {
            setTab('6');
        } else if (type === dealTypes.fund) {
            setTab('4');
        } else if (type === dealTypes.debt) {
            setTab('1');
        } else {
            setTab('6');
        }
    }, [tab, type]);

    const issuerUUID = useSelector((state: RootState) => state.investments.investmentDetails?.issuer?.issuerUUID);
    const dealUUID = useSelector((state: RootState) => state.investments.investmentDetails?.dealUUID);

    useEffect(() => {
        if (investmentUUID) {
            dispatch(InvestmentsActions.fetchInvestmentDetails(investmentUUID));
        }
    }, [dispatch, investmentUUID]);

    useEffect(() => {
        if (dealUUID && dealUUID !== 'undefined') {
            dispatch(InvestmentsActions.fetchExecutedAgreements(dealUUID));
            dispatch(InvestmentsActions.fetchUpdatesOrReporties(dealUUID));
        }
    }, [dispatch, dealUUID]);

    const dealType = useMemo(() => {
        if (type) {
            return type;
        }
        if (bookingUUID) {
            return dealTypes.debt;
        }
        return undefined;
    }, [type, bookingUUID]);

    useEffect(() => {
        if (dealType === dealTypes.fund && dealUUID && investorUUID) {
            dispatch(InvestmentsActions.fetchPPM(dealUUID, investorUUID));
        }
        if (dealType === dealTypes.debt && investmentUUID) {
            dispatch(InvestmentsActions.fetchCashflow(investmentUUID));
            dispatch(InvestmentsActions.fetchGuarantees(investmentUUID));
            dispatch(InvestmentsActions.fetchSecurities(investmentUUID));
            dispatch(InvestmentsActions.fetchCovenants(investmentUUID));
        }
    }, [dealType, dealUUID, investorUUID, dispatch, investmentUUID]);

    useEffect(() => {
        if (issuerUUID && dealType === dealTypes.debt) {
            dispatch(InvestmentsActions.fetchReportingObligation(issuerUUID));
        }
    }, [issuerUUID, dispatch, dealType]);

    return (
        <div className={common_container}>
            {loading && (
                <div className="flex justify-center items-center h-10">
                    <Spin />
                </div>
            )}
            {!loading && (
                <>
                    <div
                        className="absolute h-60 md:h-52 w-full left-0 right-0 top-20 "
                        style={{ backgroundColor: '#1B3E8C' }}
                    />
                    <div className="relative">
                        <div className="p-6 px-0 pt-10 md:p-12 md:px-0">
                            <div className="flex items-center">
                                <label
                                    className="text-white flex items-center text-sm font-bold cursor-pointer"
                                    onClick={() => navigate(HEADERMENU_PATH.investments)}
                                >
                                    <BiArrowBack size={'1.2rem'} className="mr-2" />
                                    Back
                                </label>
                            </div>
                            <InvestmentDetailCard />
                        </div>
                        <div className="md:p-12 md:pt-0 h-full md:px-2" style={{ backgroundColor: '#f0f2f5' }}>
                            <div className="bg-white w-full md:rounded-lg" style={{ minHeight: '15rem' }}>
                                <Tabs activeKey={activeTab} className="investment_tab" onChange={(v) => setTab(v)}>
                                    {type === dealTypes.debt && (
                                        <TabPane tab="Repayment Schedule" key="1" className="text-base font-bold">
                                            <RepaymentSchedules />
                                        </TabPane>
                                    )}
                                    {dealType === dealTypes.fund && (
                                        <TabPane tab="Performance" key="4" className="text-base font-bold">
                                            <Performances />
                                        </TabPane>
                                    )}
                                    {dealType === dealTypes.fund && (
                                        <TabPane tab="Distribution" key="5" className="text-base font-bold">
                                            <InvestmentDistribution />
                                        </TabPane>
                                    )}
                                    {/* <TabPane tab="Reporting" key="2" className="text-base font-bold">
                                        <ReportingOrUpdates />
                                    </TabPane>
                                    <TabPane tab="Executed Agreements" key="3" className="text-base font-bold">
                                        <ExecutedAgreements />
                                    </TabPane> */}
                                    <TabPane tab="Documents" key="6" className="text-base font-bold">
                                        <InvestmentDocuments />
                                    </TabPane>
                                    {dealType === dealTypes.debt && (
                                        <TabPane tab="Information" key="7" className="text-base font-bold">
                                            <BookingInformation />
                                        </TabPane>
                                    )}
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default InvestmentDetails;
